export const SET_POINT_MAP = "SET_POINT_MAP";
export const SET_POINT_MAP_STATION = "SET_POINT_MAP_STATION"

export const setPointMap = (points) => (  
{    
  type: SET_POINT_MAP,
  payload: points,
});

export const setPointMapStation = (pointsStation) => (  
{    
  type: SET_POINT_MAP_STATION,
  payload: pointsStation,
});


const mapActions = {
  SET_POINT_MAP, 
  SET_POINT_MAP_STATION,
  setPointMap,
  setPointMapStation,
}
export default mapActions